type MainProps = {
  children: React.ReactNode;
};

export default function Main({ children }: MainProps) {
  return <main className="flex-shrink-0 flex-1">{children}</main>;
}
